import React from "react";
import {
  Box,
  Typography,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { getLang } from "app/feature/constants";
import CampaignTngDisbursementTable from "../../table/campaignTngDisbursementTable";

export default function CampaignTngDisbursementPanelComponent({
  lang,
  campaignLogs,
  totalFiltered,
  isFetching,
  isError,
  handleChangePage,
  handleChangeRowsPerPage,
  tableFilter,
  handleReload,
  paginationOptions,
  handleExport,
  disbursementInfo,
  campaignFilter,
  onCampaignFilterChange,
}) {
  const getDescKey = (filter) => {
  switch (filter) {
      case "live":
        return "paragraph.CAMPAIGN_TNG_DISBURSEMENT_DESC_LIVE";
      case "past":
        return "paragraph.CAMPAIGN_TNG_DISBURSEMENT_DESC_PAST";
      default:
        return "paragraph.CAMPAIGN_TNG_DISBURSEMENT_DESC";
    }
  };
  return (
    <Box>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="body1">
          <b>{getLang(lang, "label.CAMPAIGN_TNG_DISBURSEMENT_TITLE")}</b>
        </Typography>
        <FormControl variant="outlined" size="small" style={{ minWidth: 180 }}>
          <InputLabel>{getLang(lang, "label.FILTER")}</InputLabel>
          <Select
            value={campaignFilter}
            onChange={(e) => onCampaignFilterChange(e.target.value)}
            label={getLang(lang, "label.FILTER")}
          >
            <MenuItem value="all">
              {getLang(lang, "label.ALL_CAMPAIGNS")}
            </MenuItem>
            <MenuItem value="live">
              {getLang(lang, "label.LIVE_AND_UPCOMING")}
            </MenuItem>
            <MenuItem value="past">
              {getLang(lang, "label.PAST_CAMPAIGNS")}
            </MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Box mt={1} mb={2}>
        <Divider />
      </Box>
      <Box mb={1.5}>
        <Typography variant="body2">
          {getLang(lang, getDescKey(campaignFilter))}
        </Typography>
      </Box>
      <Box>
        <CampaignTngDisbursementTable
          rows={campaignLogs}
          isFetching={isFetching}
          isError={isError}
          handleReload={handleReload}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          totalFiltered={totalFiltered}
          paginationOptions={paginationOptions}
          tableFilter={tableFilter}
          lang={lang}
          handleExport={handleExport}
          disbursementInfo={disbursementInfo}
          campaignFilter={campaignFilter}
        />
      </Box>
    </Box>
  );
}
